import {
  AddressType,
  enumAddressType,
} from '@rematter/frontend-lib-api-client';

import { cn } from '../../..';

export type FormattedAddressProps = {
  streetAddress: string;
  streetAddress2?: string | null;
  city: string;
  state: string;
  postalCode: string;
  singleLine?: boolean;
  addressType?: AddressType;
};

export const formatAddress = (address: FormattedAddressProps) => {
  const street = address.streetAddress2
    ? `${address.streetAddress}, ${address.streetAddress2}`
    : address.streetAddress;
  return `${street} - ${address.city}, ${address.state} - ${address.postalCode}`;
};

export const FormattedAddress = ({
  streetAddress,
  streetAddress2,
  city,
  state,
  postalCode,
  singleLine = false,
  addressType,
}: FormattedAddressProps) => {
  const fullStreet = streetAddress2
    ? `${streetAddress}, ${streetAddress2}`
    : streetAddress;

  return (
    <div
      className={cn(
        '@FormattedAddress flex w-full flex-col',
        singleLine && 'flex-row',
      )}
    >
      {addressType === enumAddressType.POBox && postalCode}
      {(addressType === enumAddressType.Standard ||
        addressType === enumAddressType.NonStandard) && (
        <>
          {singleLine && (
            <div className="w-0 grow truncate">
              {fullStreet} – {city}, {state} – {postalCode}
            </div>
          )}
          {!singleLine && (
            <>
              <div>{fullStreet}</div>
              <div>
                {city}, {state} – {postalCode}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};
